import { useStyletron } from '@thanx/uikit/theme'
import Badge from 'components/Badge'
import { buildTranslate } from 'locales'
import { LoyaltyStatus } from 'models/Card'
import React from 'react'
import {
  BadgeAppearance,
  badgeStyle,
  UNAVAILABLE_APPEARANCE,
} from './badgeAppearance'

const t = buildTranslate('users.view.cards')

type PropsT = {
  status: LoyaltyStatus | null
}

function loyaltyStatusAppearance(
  status: LoyaltyStatus | null
): BadgeAppearance {
  switch (status) {
    case 'earning':
      return { labelKey: 'loyalty_badge.earning', tone: 'positive' }
    case 'linkable':
      return { labelKey: 'loyalty_badge.linkable', tone: 'neutral' }
    case 'failed':
      return { labelKey: 'loyalty_badge.failed', tone: 'negative' }
    case 'other_account':
      return { labelKey: 'loyalty_badge.other_account', tone: 'warning' }
    case 'ineligible_type':
      return { labelKey: 'loyalty_badge.ineligible_type', tone: 'neutral' }
    case null:
      return { labelKey: 'loyalty_badge.not_required', tone: 'neutral' }
    default:
      return UNAVAILABLE_APPEARANCE
  }
}

const LoyaltyStatusBadge = ({ status }: PropsT) => {
  const [css] = useStyletron()
  const { labelKey, tone } = loyaltyStatusAppearance(status)

  return (
    <Badge value={t(labelKey)} className={`ml-xs ${css(badgeStyle(tone))}`} />
  )
}

export default LoyaltyStatusBadge
